<template>
  <v-app>
    <NavBar v-if="$route.name == 'home'" />
    <NavBar2 v-else-if="$route.name == 'login' || $route.name == 'register' || $route.name == 'forgot_password'" />
    <div v-else
      style="padding-top:0px;padding-left:0px;padding-right:0px;padding-bottom:100px"
    >
      <NavBar3 />
    </div>
    <div style="border:none;padding:0px;margin:0px;position:fixed;z-index:120;right:100px;top:110px">
      <b-alert
        :show="components.bootstrap_alert.dismissCountDown"
        style="width:400px"
        :variant="components.bootstrap_alert.variant"        
        dismissible
        fade
        @dismissed="components.bootstrap_alert.dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
      >
        {{ components.bootstrap_alert.alert_text }}  
      </b-alert> 
    </div>
    <router-view></router-view>
    <BottomSheet v-if="$route.name != 'login' && $route.name != 'register' && $route.name != 'forgot_password'" />
    <SiteFooter v-if="$route.name != 'login' && $route.name != 'register' && $route.name != 'checkout' && $route.name != 'forgot_password'" />
    <NavDrawer  v-if="$route.name != 'login' && $route.name != 'register' && $route.name != 'checkout'  && $route.name != 'support' && $route.name != 'forgot_password'" />
    <div v-if="isDialogOpen && $route.name != 'login' && $route.name != 'register' && $route.name != 'checkout' && $route.name != 'support' && $route.name != 'forgot_password'" 
        class="chat-widget"
      >
        <header class="chat-header">
          <v-col
            cols="12"
            sm="10"
            class="ma-0 pa-0"
          >
            <h2>Customer Support</h2>
          </v-col>
          <v-col
            cols="12"
            sm="2"
            class="ma-0 pa-0"
            color="white"
          >
            <v-btn
              text
              dark
              @click="showDialog"
            >
              <v-icon dark>mdi-minus</v-icon>
            </v-btn>
          </v-col>
        </header>
        <ChatModal
          v-if="isNameVisible"
          :username="userId"
          @update-input="handleInput"
          @submit-username="launchChat"
        />     
        <ChatBody
          v-if="!isNameVisible"
          :newMessage="newMessage"
          :currentUser="currentUser"
          :messages="messages"
          @send-message="sendMessage"
          @update-input="handleInput"
        />
        <ChatFooter
          v-if="!isNameVisible"
          :newMessage="newMessage"
          :currentUser="currentUser"
          :messages="messages"
          @send-message="sendMessage"
          @update-input="handleInput"
        /> 
      </div>
      <div v-if="!isDialogOpen && $route.name !== 'login' && $route.name !== 'register' && $route.name !== 'checkout' && $route.name !== 'support' && $route.name != 'forgot_password'"
        class="chat-button"
      >
        <v-btn
          color="rgb(5,47,102,0.80)"
          large
          fab
          dark
          @click="showDialog();shiftDrawer()"
        >
          <v-icon>mdi-chat</v-icon>
        </v-btn>
      </div>
  </v-app>
</template>
<script>
  import './chat/Chat.css';

  import NavBar from "@/components/NavBar.vue";
  import NavBar2 from "@/components/NavBar-2.vue";
  import NavBar3 from "@/components/NavBar-3.vue";
  import NavDrawer from "@/components/NavDrawer.vue";
  import BottomSheet from "@/components/BottomSheet.vue";
  import SiteFooter from "@/components/SiteFooter.vue";

  import ChatBody from '@/components/ChatBody.vue';
  import ChatFooter from '@/components/ChatFooter.vue';
  import ChatModal from '@/components/modals/ChatModal.vue';
  import { sendMessage, showDialog, launchChat, createRoom, addSupportStaffToRoom, connectToRoom, handleInput } from './chat/chat.js';
  import { mapGetters } from "vuex";

  export default {
    name:"App",
    components: {
      NavBar,
      NavBar2,
      NavBar3,
      NavDrawer,
      BottomSheet,
      SiteFooter,
      ChatModal,
      ChatBody,
      ChatFooter
    },
    data() {
      return {
        title: 'Customer Support',
        userId: '',
        currentUser: null,
        currentRoom: null,
        newMessage: '',
        messages: [],
        isDialogOpen: false,
        isNameVisible: true
      }
    },
    methods: {
      sendMessage,
      showDialog,
      handleInput,
      launchChat,
      createRoom,
      addSupportStaffToRoom,
      connectToRoom,
      shiftDrawer(){
        this.components.nav_drawer.right = false;
      },
      countDownChanged(dismissCountDown) {
        this.components.bootstrap_alert.dismissCountDown = dismissCountDown
      }
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    },
    created(){
      
    }
  }
</script>

